import { render, staticRenderFns } from "./SessionInfo.vue?vue&type=template&id=585f6639&scoped=true"
import script from "./SessionInfo.vue?vue&type=script&lang=js"
export * from "./SessionInfo.vue?vue&type=script&lang=js"
import style0 from "../style/side-box.scss?vue&type=style&index=0&id=585f6639&prod&scoped=true&lang=scss&external"
import style1 from "../style/staff.scss?vue&type=style&index=1&id=585f6639&prod&scoped=true&lang=scss&external"
import style2 from "../style/session-info.scss?vue&type=style&index=2&id=585f6639&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f6639",
  null
  
)

export default component.exports